import { render, staticRenderFns } from "./AppFloatingButton.vue?vue&type=template&id=3caa39c8&"
import script from "./AppFloatingButton.vue?vue&type=script&lang=js&"
export * from "./AppFloatingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports